import { HttpClient } from '@angular/common/http'
import { Inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { AppConfig, APP_CONFIG } from 'src/app.config';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  public API_URL: string;

  constructor(
    @Inject(APP_CONFIG) appConfig: AppConfig,
    private http: HttpClient
  ) {
    this.API_URL = appConfig.urlApi;
  }

  getAllReportShared(startDate: any, endDate: any): Observable<any> {
    const url =
      this.API_URL +
      '/Reports/Shared?afterDate=' +
      startDate +
      '&beforeDate=' +
      endDate;
    return this.http.get<any>(url);
  }

  getAllReportStatistics(startDate: any, endDate: any): Observable<any> {
    const url =
      this.API_URL +
      '/Reports/Statistics?afterDate=' +
      startDate +
      '&beforeDate=' +
      endDate;
    return this.http.get<any>(url);
  }
}
